import React from "react";
import { Col } from "react-bootstrap";
import { WfControlProps } from "./ControlProps";
import { Input, InputNumber, InputProps } from "antd";
import ComponentLabel from "../../../../../../components/ControlComponents/ComponentLabel";
import styles from "./Number.module.css";

export function WfNumber({
  layout,
  layoutLength,
  fieldState,
  inputProps,
}: Readonly<WfControlProps>) {
  function formatter(value: any) {
    if (value === undefined || value === null) {
      return "";
    }
    let v = value;
    if (typeof value === "string") {
      v = parseFloat(value.replace(/[^0-9.]/g, ""));
    }
    return Number.isNaN(v)
      ? ""
      : v.toLocaleString("en-US", {
          minimumFractionDigits: layout.template?.attribute?.decimal,
          maximumFractionDigits: layout.template?.attribute?.decimal,
        });
  }
  return (
    <>
      <ComponentLabel
        colText={2}
        rowIdx={1}
        colIdx={0}
        template={layout.template}
      />
      <Col xs={12} lg={layoutLength === 1 ? 10 : 4}>
        <Input
          {...(inputProps as InputProps)}
          addonAfter={layout.template?.attribute?.symbol}
          className={styles.formInputNumber}
          onChange={(e) => {
            const props = inputProps as InputProps;
            if (props.onChange) {
              e.target.value = e.target.value.replace(/[^0-9.]/g, "");
              props.onChange(e);
            }
          }}
          onBlur={(e) => {
            const props = inputProps as InputProps;
            if (props.onChange) {
              e.target.value = formatter(e.target.value);
              props.onChange(e);
            }
          }}
        />
        {fieldState.error && (
          <>
            <small className="text-danger">{fieldState.error.message}</small>
          </>
        )}
      </Col>
    </>
  );
}
